import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './pageTemplate.css'
/**
 * creat by tianruojun
 * @description 一个普通页面的外壳，主要实现内外层css
 * @class PageTemplate
 * @extends {Component}
 */
export default class PageTemplate extends Component {
    static propTypes = {
        style: PropTypes.object,
        styleOut: PropTypes.object,
        key: PropTypes.string,
    };
    static defaultProps = {
        style: {},
        styleOut: {},
        key: 'PageTemplate'
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className={'page-template-out'} style={this.props.styleOut}>
                <div className={'page-template'} style={this.props.style}>
                    {this.props.children}
                </div>
            </div>
        )
    }

}